import React from 'react';
import { Mail } from 'lucide-react';
import PageHeader from '../components/PageHeader';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-4xl mx-auto">
          <div className="text-center">
            <h1 className="text-3xl font-extrabold text-gray-900">Contact Us</h1>
            <p className="mt-4 text-lg text-gray-500">
              Have questions? We're here to help.
            </p>
          </div>

          <div className="mt-12 max-w-2xl mx-auto">
            <div className="bg-white shadow-sm rounded-lg p-8">
              <h2 className="text-lg font-medium text-gray-900 mb-4">Email support</h2>
              <p className="text-sm text-gray-500 mb-6">
                Contact ZoneDM for installation, account, or integration support. We respond within one business day.
              </p>
              <a
                href="mailto:jennifer@zonedm.com"
                className="inline-flex items-center text-indigo-600 hover:text-indigo-500 font-medium"
              >
                <Mail className="w-5 h-5 mr-3" />
                jennifer@zonedm.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
